import {
  SoDataTableColumnType,
  SoDataTableHeader,
} from "@/types/components/SoDataTable"
import { SoRadioCardChartType } from "@/types/components/SoRadioCardChart"
import { BRAND_COLORS } from "@/theme/colorPalette"

export type SmartChargingKpiName =
  "eligibilityChecks" | "waitlist" | "compatibleChecks" | "compatibleWaitlist"

export type SmartChargingKpi = {
  name: SmartChargingKpiName
  label: string
  type: SoRadioCardChartType
  isPercentage: boolean
}

export const kpiCards: SmartChargingKpi[] = [
  {
    name: "eligibilityChecks",
    label: "EV tariff eligibility checks",
    type: "caution",
    isPercentage: false,
  },
  {
    name: "compatibleChecks",
    label: "Compatible Accounts",
    type: "neutral",
    isPercentage: true,
  },
  {
    name: "compatibleWaitlist",
    label: "Compatible Accounts (waitlist)",
    type: "normal",
    isPercentage: true,
  },
  {
    name: "waitlist",
    label: "Accounts on waitlist",
    type: "neutral",
    isPercentage: false,
  },
]

export const accountsTableHeaders: SoDataTableHeader[] = [
  {
    title: "Account",
    key: "accountNumber",
    sortable: false,
    fallbackValue: "-",
  },
  {
    title: "Axle site ID",
    key: "axleSiteId",
    type: SoDataTableColumnType.COPY_TO_CLIPBOARD,
    sortable: false,
    fallbackValue: "-",
  },
  {
    title: "Meter point",
    key: "meterPointIdentifier",
    fallbackValue: "-",
  },
  {
    title: "Onboarded",
    key: "onboardedAt",
    type: SoDataTableColumnType.DATE,
    fallbackValue: "-",
  },
  {
    title: "Offboarded",
    key: "offboardedAt",
    type: SoDataTableColumnType.DATE,
    fallbackValue: "-",
  },
  {
    title: "Created",
    key: "createdAt",
    type: SoDataTableColumnType.DATE,
  },
]

// Brand palette, cycled when a chart has more slices than colours.
export const PIE_COLORS: string[] = [
  BRAND_COLORS.fire,
  BRAND_COLORS.sun,
  BRAND_COLORS.earth,
  BRAND_COLORS.sky,
  BRAND_COLORS["fire-light"],
  BRAND_COLORS["sun-light"],
  BRAND_COLORS["earth-light"],
  BRAND_COLORS["sky-light"],
  BRAND_COLORS["fire-dark"],
  BRAND_COLORS["sun-dark"],
  BRAND_COLORS["earth-dark"],
  BRAND_COLORS["sky-dark"],
]
